import { Subject } from "rxjs";
import { Block } from "./block";

export abstract class IBlockRepository {
  updated: Subject<Block>;
  created: Subject<Block>;
  deleted: Subject<Block>;
  abstract get(nameFilter?: string, blockId?: number): Promise<Block[]>;
  abstract create(name: string): Promise<Block>;
  abstract update(block: Block): Promise<void>;
  abstract delete(blockId: number): Promise<void>;
}
